/*

  s e t t i n g s
  Settings

  :description:
  A file to hold our settings.

*/

//import { version } from "../package.json"

export const VERSION = `v1.0.33`

export const BASE_URI_DEV = `https://events-endpoint-dev.pointandplace.com`
export const BASE_URI_PROD = `https://events-endpoint.pointandplace.com`

export const URLS = {
  dev: {
    projects: {
      log: `${BASE_URI_DEV}/projects/events`,
      error: `${BASE_URI_DEV}/projects/error`,
    },
    syndication: {
      log: `${BASE_URI_DEV}/syndication/events`,
      error: `${BASE_URI_DEV}/syndication/error`,
    },
    syndicationCoverage: {
      log: `${BASE_URI_DEV}/syndication/coverage`
    }
  },
  prod: {
    projects: {
      log: `${BASE_URI_PROD}/projects/events`,
      error: `${BASE_URI_PROD}/projects/error`,
    },
    syndication: {
      log: `${BASE_URI_PROD}/syndication/events`,
      error: `${BASE_URI_PROD}/syndication/error`,
    },
    syndicationCoverage: {
      log: `${BASE_URI_PROD}/syndication/coverage`
    }
  }
}
